import { SxProps, Theme } from '@mui/material';

const filterContainer: SxProps<Theme> = {
  display: 'flex',
};

const styles = {
  filterContainer,
};

export default styles;
